var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ConfirmToolbar } from '../common/Toolbar';
import { useRouter } from '../../context/router-context';
import Loading from '../common/Loading';
import { Body } from '../root/PageRouter';
import regEx from '../../utils/regex';
import { getContentType } from './content-helpers';
import { Button } from '../common/button';
import { AlertDialog } from '../common/alert-dialog';
import { List, ListItemInput, ListItemSelect, ListItemSwitch, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
import { refetchContentListQuery, useDeleteContentMutation, useUpdateContentMutation, useUpdateContentPageQuery, } from '../../__generated__/graphql';
function Toolbar(props) {
    return (_jsx(ConfirmToolbar, __assign({ disabled: props.disabled, onClick: props.onClick }, { children: props.children }), void 0));
}
export default function UpdateContent() {
    var _this = this;
    // Router
    var _a = useRouter(), match = _a.match, goBack = _a.goBack;
    // GraphQL query
    var _b = useUpdateContentPageQuery({
        variables: { id: match.params.contentId },
    }), data = _b.data, loading = _b.loading;
    var content = data === null || data === void 0 ? void 0 : data.content;
    // Events
    var noEvent = { id: '', name: 'No event' };
    var storedEvents = (data === null || data === void 0 ? void 0 : data.events) || [];
    var events = __spreadArrays([noEvent], storedEvents);
    // State
    var _c = useState(''), label = _c[0], setLabel = _c[1];
    var _d = useState(''), title = _d[0], setTitle = _d[1];
    var _e = useState(''), description = _e[0], setDescription = _e[1];
    var _f = useState(''), url = _f[0], setUrl = _f[1];
    var _g = useState(''), previewUrl = _g[0], setPreviewUrl = _g[1];
    var _h = useState(''), imageUrl = _h[0], setImageUrl = _h[1];
    var _j = useState(''), eventId = _j[0], setEventId = _j[1];
    var _k = useState(false), deleteDialogIsOpen = _k[0], setDeleteDialogIsOpen = _k[1];
    var _l = useState(false), isPublic = _l[0], setIsPublic = _l[1];
    // Initialize state
    useEffect(function () {
        var _a;
        if (content && content.__typename === 'Content') {
            setLabel(content.label);
            setTitle(content.title);
            setDescription(content.description);
            setUrl(content.url);
            setPreviewUrl(content.previewUrl || '');
            setImageUrl(content.imageUrl || '');
            setEventId(((_a = content.event) === null || _a === void 0 ? void 0 : _a.id) || '');
            setIsPublic(content.public);
        }
    }, [content]);
    // GraphQL mutation
    var updateContent = useUpdateContentMutation({
        variables: {
            input: {
                contentId: match.params.contentId,
                label: label.trim(),
                title: title.trim(),
                description: description.trim(),
                url: url.trim(),
                previewUrl: previewUrl ? previewUrl.trim() : null,
                imageUrl: imageUrl.trim() || undefined,
                type: getContentType(url.trim()),
                eventId: eventId === '' ? null : eventId,
                public: isPublic,
            },
        },
    })[0];
    // GraphQL mutation
    var deleteContentMutation = useDeleteContentMutation({
        variables: {
            input: {
                contentId: match.params.contentId,
            },
        },
        refetchQueries: [refetchContentListQuery()],
    })[0];
    var disabled = !label ||
        (label && regEx.trimmedString.test(label.trim())) === false ||
        label.trim().length > 100 ||
        label.trim().length < 1 ||
        !title ||
        (title && regEx.trimmedString.test(title.trim())) === false ||
        title.trim().length > 100 ||
        title.trim().length < 1 ||
        !description ||
        description.trim().length > 1000 ||
        // Note: The textInput will only accept 1000 characters and cut the text after 1000 char.
        // Consequently the disable function will not be utilized as long as
        // a supported browser is used, and the HTMLInputElement is displayed as expected.
        description.trim().length < 1 ||
        !url ||
        url.trim().length > 1000 ||
        !regEx.url.test(url.trim()) ||
        imageUrl.trim().length > 1000 ||
        (imageUrl && regEx.url.test(imageUrl)) === false;
    // Event handlers
    var openDeleteDialog = function () {
        setDeleteDialogIsOpen(true);
    };
    var closeDeleteDialog = function () {
        setDeleteDialogIsOpen(false);
    };
    var confirmDeleteContent = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = deleteContentMutation();
                    setDeleteDialogIsOpen(false);
                    goBack();
                    // To ensure we do not end up on the deleted items details page we go back two times.
                    goBack();
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!content) {
        throw new Error('Content query failed (content not found)');
    }
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog, { "data-test": "delete-content-dialog", isOpen: deleteDialogIsOpen, title: "Delete this content?", content: "This action cannot be undone.", onBackdropClick: closeDeleteDialog, buttons: [
                    {
                        label: 'Delete',
                        primary: true,
                        onClick: confirmDeleteContent,
                    },
                    {
                        label: 'Cancel',
                        onClick: closeDeleteDialog,
                    },
                ] }, void 0),
            _jsx(Toolbar, __assign({ disabled: disabled, onClick: updateContent }, { children: "Edit Content" }), void 0),
            _jsxs(Body, { children: [_jsxs(List, { children: [_jsx(ListItemInput, { type: "text", label: "Label", value: label, onChange: setLabel }, void 0),
                            _jsx(ListItemInput, { type: "text", label: "Title", value: title, onChange: setTitle }, void 0),
                            _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription }, void 0),
                            _jsx(ListItemInput, { type: "text", label: "Url", value: url, onChange: setUrl }, void 0),
                            _jsx(ListItemInput, { type: "text", label: "Url for image", value: imageUrl, onChange: setImageUrl }, void 0),
                            _jsx(ListItemSelect, { label: "Event", value: eventId, onChange: setEventId, options: events }, void 0),
                            _jsx(ListItemSwitch, { primary: "Public", wrapPrimary: true, checked: isPublic, onClick: function () { return setIsPublic(!isPublic); } }, void 0),
                            _jsx(ListItemInput, { type: "text", label: "Preview URL", value: previewUrl || '', onChange: setPreviewUrl }, void 0)] }, void 0),
                    _jsx(Button, __assign({ "data-test": "open-delete-dialog-button", onClick: openDeleteDialog }, { children: "Delete" }), void 0)] }, void 0)] }, void 0));
}
//# sourceMappingURL=UpdateContent.js.map